import styled from 'styled-components';

import { ActionButton } from 'components/action-button';

export const AddressList = styled.div`
  margin: 2rem 0;
`;

export const AddressContainer = styled.label`
  width: 100%;
  padding: 1rem;
  border: 1px solid ${Styles.color.grey.four};
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-block-start: -1px; /* for overlapping borders */
  border-inline-end: 0;
  border-inline-start: 0;
  justify-content: center;
  border-radius: 0;
`;

export const RadioButtonContainer = styled.div`
  width: 250px;
  margin-inline-start: 2rem;

  ${Styles.desktop} {
    width: 300px;
  }
`;

export const ShareLocationButton = styled(ActionButton)`
  cursor: pointer;
  margin-inline-start: auto;
  line-height: 2.375rem;
`;

export const WarningContainer = styled.div`
  margin: 1.5rem;
`;
